export default __webpack_public_path__ + "static/media/card_img_active_3_3.eaf5273d.png";